export default __webpack_public_path__ + "static/media/oserLogo.10d5e2f7.svg";